"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _FormGroup = _interopRequireDefault(require("reactstrap/lib/FormGroup"));

var _utils = require("../lib/utils");

var _excluded = ["footer", "last", "dataTestId"];

var FormGroup = function FormGroup(props) {
  var footer = props.footer,
      last = props.last,
      dataTestId = props.dataTestId,
      attr = (0, _objectWithoutProperties2["default"])(props, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_FormGroup["default"], (0, _extends2["default"])({
    "data-testid": dataTestId,
    className: (0, _utils.gatherClasses)(attr, footer ? "oui-text-right" : null, last ? "oui-mb-0" : null)
  }, attr), attr.children);
};

FormGroup.propTypes = {
  children: _propTypes["default"].node,
  // Applied the row class when true, does nothing when false
  row: _propTypes["default"].bool,
  // Applied the form-check class when true, form-group when false
  check: _propTypes["default"].bool,
  footer: _propTypes["default"].bool,
  inline: _propTypes["default"].bool,
  // Applied the disabled class when the check and disabled props are true, does nothing when false
  disabled: _propTypes["default"].bool,
  last: _propTypes["default"].bool,
  // Pass in a Component to override default element
  className: _propTypes["default"].string,
  dataTestId: _propTypes["default"].string
};
FormGroup.defaultProps = {
  row: false,
  check: false,
  inline: false,
  last: false,
  disabled: false,
  dataTestId: "orion-form-group"
};
FormGroup.displayName = "OrionFormGroup";
var _default = FormGroup;
exports["default"] = _default;